import { LifecyclePermissions } from "server/models"
import {
    GET,
    POST,
    CommonPermissions,
    CommonPermissionsSectioned,

    createLifecyclePermissions,
    copyCommonPermission,
} from "client/store/utils"
import { LangType } from "client/store"


export const LoadLifecyclePermissions = (
    lifecycleId: number,
    lang?: LangType,
) => (
    GET(`/lifecyclePermissions/lifecycleId/${lifecycleId}`)
    .then((res: LifecyclePermissions) => {
        const lifecyclePermissions = res && res.permissions ? JSON.parse(res.permissions) : {}

        const initPermissions = createLifecyclePermissions(lang || null)
        const permissions = <CommonPermissions>initPermissions.permissions
        const permissionsSectioned = <CommonPermissionsSectioned>initPermissions.permissionsSectioned

        Object.keys(permissionsSectioned).forEach((section) => {
            Object.keys(permissionsSectioned[section]).forEach((permissionId: string) => {
                let resPermission = permissions[permissionId]
                resPermission = copyCommonPermission(resPermission, lifecyclePermissions[permissionId], true)

                permissions[permissionId] = copyCommonPermission(permissions[permissionId], resPermission, true)
                permissionsSectioned[section][permissionId] = copyCommonPermission(
                    permissionsSectioned[section][permissionId],
                    resPermission,
                    true,
                )
            })
        })

        return { permissions, permissionsSectioned }
    })
)

export const SaveLifecyclePermissions = (
    lifecycleId: number,
    permissionsSectioned: CommonPermissionsSectioned,
) => {
    const permissions: CommonPermissions = {}

    Object.keys(permissionsSectioned).forEach((section) => {
        Object.keys(permissionsSectioned[section]).forEach((permissionId) => {
            permissions[permissionId] = permissionsSectioned[section][permissionId]
        })
    })

    const data: LifecyclePermissions = {
        lifecycleId,
        permissions: JSON.stringify(permissions),
    }

    return POST(
        "/lifecyclePermissions/save",
        JSON.stringify(data),
    )
}
